<template>
  <div :class="$style.container">
    <BadgeBar :items="filters" :active="active" @on-badge-click="handleClick" />
  </div>
</template>

<script lang="ts" setup>
import BadgeBar from '@/components/common/BadgeBar/BadgeBar.vue';
import { GroupedPropertyData } from '@/components/property-overview-page/MyProperties/adaptData';
import { OfferType } from '@/models/valuationFunnel';
import { trackingClickEvent } from '@/tracking/tracking';
import { TRACKING_BADGE_FILTER_ACTION, TRACKING_LABEL } from '@/tracking/types';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

export type FilterType = 'all' | OfferType;
export interface Props {
  groupedPropertyData: GroupedPropertyData[];
  active: FilterType;
}

const props = defineProps<Props>();
const emit = defineEmits<(event: 'onBadgeClick', type: FilterType) => void>();

const { t } = useI18n();

const filters = computed<{ label: string; value: FilterType }[]>(() => [
  {
    label: t('overview.subtitle.all'),
    value: 'all',
  },
  ...props.groupedPropertyData
    .filter((group) => group.items.length > 0)
    .map((group) => ({
      label: t(`overview.subtitle.${OfferType[group.type].toLowerCase()}`),
      value: group.type,
    }))
    .sort((a, b) => {
      if (a.value === OfferType.Own) return -1;
      if (b.value === OfferType.Own) return 1;
      return 0;
    }),
]);

const handleClick = (value: string | number) => {
  const type = value as FilterType;
  trackingClickEvent(TRACKING_BADGE_FILTER_ACTION[type], TRACKING_LABEL.BADGE_FILTER_BAR, false);
  emit('onBadgeClick', type);
};
</script>

<style lang="scss" module>
@use '@/assets/variables' as *;

.container {
  margin-bottom: $space-150;
}
</style>
